var dom = require('./dom')
exports.DOMImplementation = dom.DOMImplementation
exports.XMLSerializer = dom.XMLSerializer
exports.DOMParser = require('./dom-parser').DOMParser



//////////////////
// WEBPACK FOOTER
// ./~/@xmldom/xmldom/lib/index.js
// module id = 102
// module chunks = 0